var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-popup",
    {
      attrs: { round: "", position: "bottom" },
      model: {
        value: _vm.isShowPicker,
        callback: function($$v) {
          _vm.isShowPicker = $$v
        },
        expression: "isShowPicker"
      }
    },
    [
      _c("van-picker", {
        ref: "pickerRef",
        attrs: {
          "show-toolbar": "",
          columns: _vm.areaList,
          "value-key": "name"
        },
        on: { cancel: _vm.closeAreaPicker, confirm: _vm.onConfirm }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b97668d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b97668d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ftAddress.vue
// module id = null
// module chunks = 